import React from 'react';
import EventTracking from 'lib/EventTracking';
import Radio from 'components/Radio';

import { CoachingStudentsAndProduct_coaching_studentFamilyMembers as Student } from '../../queries/__generated__/CoachingStudentsAndProduct';

type Props = {
  students: Student[];
  selectedChildName: null | string;
  onChildSelection: (e: React.FormEvent<HTMLInputElement>) => void;
};

export default class StudentsView extends React.Component<Props> {
  componentDidMount() {
    EventTracking.trackKey('coaching.select_student.view');
  }

  render() {
    return this.props.students.map((student: Student, idx) => {
      const { name } = student;
      return (
        <Radio
          key={idx}
          label={name}
          name={name}
          checked={this.props.selectedChildName === name}
          onChange={e => {
            EventTracking.trackKey('coaching.select_student.select_student.click');
            this.props.onChildSelection(e);
          }}
        />
      );
    });
  }
}
